import moment from 'moment';
moment.locale('fr');

export const defaultConfigFormat = 'DD/MM/YYYY HH:mm';
export const defaultReadableFormat = 'dddd DD/MM HH:mm';
export const before = 'too-soon';
export const after = 'too-late';

export function getDateFromConfig(dateStr: string): string {
    return moment(dateStr, defaultConfigFormat).format();
}

export function dateToStr(dateString: string) {
    return moment(dateString, defaultConfigFormat).format(defaultReadableFormat);
}

/**
 * Tell if current date is between two dates
 * @param from
 * @param to
 */
export function isBetween(from: string, to: string): boolean {
    const fromBase = moment(getDateFromConfig(from));
    const toBase = moment(getDateFromConfig(to));
    if (fromBase.isAfter(toBase)) {
        fromBase.subtract(1, 'week');
    }
    return moment().isBetween(fromBase, toBase);
}

export function tooSoonOrTooLate(from: string): string {
    return moment().isBefore(getDateFromConfig(from)) ? before : after;
}
